module.exports = __webpack_public_path__ + "static/media/google_logo.c1696373.png";